import { render, staticRenderFns } from "./PageAnnouncement.vue?vue&type=template&id=9e3505ac&"
import script from "./PageAnnouncement.vue?vue&type=script&lang=ts&"
export * from "./PageAnnouncement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports